import React, { useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'

import PropTypes from 'prop-types'

import map from 'lodash/map'

import {
  Divider,
  Grid,
  Typography
} from '@material-ui/core'

import { useDialog } from '@galo-monitor/dialog'
import { useT } from '@galo-monitor/i18n'
import { edit } from '@galo-monitor/icons'
import colors from '@galo-monitor/styles/colors'
import Card from '@galo-monitor/web-components/Card'
import Icon from '@galo-monitor/web-components/Icon'
import IconButton from '@galo-monitor/web-components/IconButton'
import FarmModal from '@galo-monitor/web-containers/modals/company/FarmModal'

import {
  CardTitle,
  SegmentChip,
  TextBold
} from './theme'

const FarmInfo = ({ farmData, mutateFarmData }) => {
  const t = useT()
  const { farmId } = useParams()
  const { createDialog } = useDialog()

  const cardsProps = useMemo(() => ({
    cardStyle: { width: '100%' },
    cardContentProps: {
      style: { padding: '5px 30px' }
    },
    headerTitleProps: {
      style: {
        flex: 0,
        marginRight: 5,
        whiteSpace: 'nowrap'
      }
    },
    style: {
      display: 'block',
      margin: 0
    }
  }), [])

  const farmInfo = useMemo(() => ({
    name: farmData?.name,
    nameResponsible: farmData?.nameResponsible,
    segment: farmData?.segment,
    phoneResponsible: farmData?.phoneResponsible,
    emailResponsible: farmData?.emailResponsible,
    plan: farmData?.plan
  }), [farmData])

  const handleEditFarm = useCallback(() =>
    createDialog({
      id: 'edit-farm',
      Component: FarmModal,
      props: {
        farm: { id: +farmId, ...farmData },
        onSuccess: updatedFarmData =>
          mutateFarmData({
            name: updatedFarmData.name,
            nameResponsible: updatedFarmData.name_responsible,
            segment: updatedFarmData.segment_name,
            phoneResponsible: updatedFarmData.phone_responsible,
            emailResponsible: updatedFarmData.email_responsible,
            plan: +updatedFarmData.plan_id
          })
      }
    }), [createDialog, farmData, farmId, mutateFarmData])

  return (
    <Card
      { ...cardsProps }
      title={ <CardTitle variant="body2">{ t('registration information') }</CardTitle> }
      headerRight={
        <IconButton size="small" onClick={ handleEditFarm }>
          <Icon size={ 15 } icon={ edit } color={ colors.darkGrey } />
        </IconButton>
      }
    >
      <Grid
        aria-label="user-info"
        direction="column"
        container
      >
        <Divider />
        {map(Object.entries(farmInfo), ([key, value]) => (
          <React.Fragment key={ key }>
            <Grid item container xs={ 12 }>
              <Grid item xs={ 12 } sm={ 6 }>
                <Typography variant="body2">
                  {t('farm info key', { key })}
                </Typography>
              </Grid>
              <Grid
                item
                xs={ 12 }
                sm={ 6 }
              >
                {key === 'segment' ? (
                  <SegmentChip label={ value || '-' } />
                ) : (
                  <TextBold variant="body2">
                    {value || '-'}
                  </TextBold>
                )}
              </Grid>
            </Grid>
            <Divider />
          </React.Fragment>
        ))}
      </Grid>
    </Card>
  )
}

FarmInfo.propTypes = {
  farmData: PropTypes.object.isRequired,
  mutateFarmData: PropTypes.func.isRequired
}

export default FarmInfo
